import ReactMarkdown from 'react-markdown';
import type { Components } from 'react-markdown';
import { toMarkdown } from '../lib/contentText';

const components: Components = {
  h1: ({ children }) => <h2 className="lesson-md-h">{children}</h2>,
  h2: ({ children }) => <h2 className="lesson-md-h">{children}</h2>,
  h3: ({ children }) => <h3 className="lesson-md-h3">{children}</h3>,
  h4: ({ children }) => <h4 className="lesson-md-h3">{children}</h4>,
  p: ({ children }) => <p>{children}</p>,
  ul: ({ children }) => <ul>{children}</ul>,
  ol: ({ children }) => <ol>{children}</ol>,
  li: ({ children }) => <li>{children}</li>,
  a: ({ href, children }) => {
    const external = typeof href === 'string' && /^https?:/i.test(href);
    return (
      <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined}>
        {children}
      </a>
    );
  },
  img: ({ src, alt }) => (
    <img src={typeof src === 'string' ? src : ''} alt={alt || ''} loading="lazy" />
  ),
  blockquote: ({ children }) => <blockquote>{children}</blockquote>,
};

interface LessonMarkdownProps {
  value: unknown;
  className?: string;
}

/**
 * Renders lesson body copy. Strings are markdown. Portable Text blocks are
 * converted first so older content still shows headings, lists, links, and images.
 */
export default function LessonMarkdown({ value, className }: LessonMarkdownProps) {
  const markdown = toMarkdown(value);
  if (!markdown) return null;

  return (
    <div className={`lesson-markdown font-myanmar ${className || ''}`}>
      <ReactMarkdown components={components}>{markdown}</ReactMarkdown>
    </div>
  );
}
